import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material';
import { BlockItemFormat } from '../';
import { MENU_WIDTH } from './Menu/constants';

interface ContentStyledProps {
  isEditing?: boolean;
  blockItemFormat: BlockItemFormat;
}
export const useStyles = makeStyles<Theme, ContentStyledProps>((theme) => ({
  actionsButton: ({ blockItemFormat }) => ({
    position: 'absolute',
    right: 0,
    top: theme.spacing(0),

    ...(blockItemFormat === BlockItemFormat.CONDENSED && {
      '& svg': {
        fill: theme.palette.grey['600'],
      },
    }),
  }),
  link: {
    position: 'relative',
    width: '100%',

    '& h6': {
      lineHeight: 1.35,
      wordBreak: 'break-all',
    },
  },
  defaultDraftField: {
    '& .public-DraftEditorPlaceholder-inner': {
      color: theme.palette.grey[400],
    },

    '& .megadraft-block, & .megadraft-editor': {
      paddingBottom: theme.spacing(0.25),
      color: theme.palette.grey[800],

      '& div > span, & .public-DraftEditorPlaceholder-inner': {
        letterSpacing: 0,
      },
    },
  },
  content: {
    '& .megadraft-block, & .megadraft-editor': {
      marginTop: theme.spacing(1),

      '& .public-DraftStyleDefault-block': {
        lineHeight: 1.25,
      },

      '& div > span, & .public-DraftEditorPlaceholder-inner': {
        fontSize: theme.typography.body1.fontSize,
      },
    },
  },
  linkLabel: {
    margin: 0,
    borderTop: `solid 1px ${theme.palette.grey[200]}`,
    marginTop: theme.spacing(6),
    paddingTop: theme.spacing(1.75),

    '& .megadraft-block, & .megadraft-editor': {
      marginTop: theme.spacing(0),

      '& .public-DraftStyleDefault-block': {
        lineHeight: 1.25,
      },

      '& div > span, & .public-DraftEditorPlaceholder-inner': {
        fontFamily: theme.typography.body1.fontFamily,
        fontSize: theme.typography.body1.fontSize,
      },
    },
  },
  surTitle: {
    margin: 0,
    maxWidth: `calc(100% - ${MENU_WIDTH}px + ${theme.spacing(2)});`,
    '& .megadraft-block': {
      paddingBottom: 0,
    },

    '& .megadraft-block, & .megadraft-editor': {
      '& .public-DraftStyleDefault-block': {
        lineHeight: 1.1,
      },

      '& div > span, & .public-DraftEditorPlaceholder-inner': {
        fontFamily: theme.typography.body2.fontFamily,
        fontSize: theme.typography.body2.fontSize,
      },
    },
  },
  title: ({ isEditing }) => ({
    maxWidth: `calc(100% - ${MENU_WIDTH}px);`,

    ...(!isEditing
      ? {
          fontWeight: 500,
          fontSize: 20,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }
      : {}),

    '& .megadraft-block, & .megadraft-editor': {
      '& div > span, & .public-DraftEditorPlaceholder-inner': {
        fontFamily: theme.typography.h5.fontFamily,
        fontSize: theme.typography.h5.fontSize,
        lineHeight: theme.typography.h5.lineHeight,
        fontWeight: 500,
      },
    },

    marginBottom: 0,
  }),
  wrapper: {
    minHeight: 40,
  },
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: theme.spacing(0.25),
  },
  paidArticle: {
    backgroundColor: 'rgb(243, 167, 18)',
    color: theme.palette.common.white,
    borderRadius: 2,
    fontSize: 14,
    padding: theme.spacing(0, 0.4),
    margin: theme.spacing(0, 1, 0, 0),
  },
}));
